const React = require('react');
const map = require('mn-utils/map');
const withState = require('../../../../utils/withState');
const {
  apiAdminOraclesList,
} = require('../../../../api/admin/oracles');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');

const OraclesItem = require('./OraclesItem');


module.exports = withState((setState, self, onMount) => {
  onMount(() => {
    setState({
      loadingOracles: 1,
    });
    return apiAdminOraclesList().finally((error, response) => {
      setState({
        oraclesItems: response && response.list || [],
        loadingOracles: 0,
      });
    }).cancel;
  });


  return (state) => {
    return (
      <WrapperWithLoading
        loading={state.loadingOracles}
      >
        {map(state.oraclesItems, (item) => {
          return (
            <div
              key={item.id}
              className={`fw5 dn o75 o100.checked `
                + (item.checked ? ' checked' : '')}
            >
              <OraclesItem
                data={item}
              />
            </div>
          );
        }, [])}
      </WrapperWithLoading>
    );
  };
}, {});
